
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter';
import { ThreeView } from "../View3dWebCad";

class ExportGLTF {

    // gltf exporter
    public export() {
        const scene = ThreeView.get().wcScene.me;
        const gltfExporter = new GLTFExporter();

        const link = document.createElement( 'a' );
        link.style.display = 'none';
        document.body.appendChild( link ); // Firefox workaround, see #6594

        const save = ( blob, filename ) => {
            link.href = URL.createObjectURL( blob );
            link.download = filename;
            link.click();
        }

        const saveString = ( text, filename ) => {
            save( new Blob( [ text ], { type: 'text/plain' } ), filename );
        }

        const saveArrayBuffer = ( buffer, filename ) => {
            save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
        }

        const visible = (name, flag) => {
            const object = scene.getObjectByName(name);
            if (object) object.visible = flag;
        }

        visible("空", false);
        visible("グリッド線", false);
        visible("雲", false);

        const options = {
            trs: true,
            onlyVisible: true,
        };
        gltfExporter.parse(
            scene,
            function ( result ) {

                if ( result instanceof ArrayBuffer ) {
                    saveArrayBuffer( result, 'scene.glb' );
                } else {
                    const output = JSON.stringify( result, null, 2 );
                    console.log( output );
                    saveString( output, 'scene.gltf' );
                }
            },
            () =>{
                console.log('error');
            },
            options
        );

        visible("空", true);
        visible("グリッド線", true);
        visible("雲", true);
    }
}

export { ExportGLTF };
